import { Subscribe } from "@react-rxjs/core"
import { useTranslation } from "react-i18next"

import { SimpleViewLayout } from "@/App/Equities/mobile/layout"
import { RootPath } from "@/App/Equities/mobile/paths"
import { ErrorBoundary, Loading } from "@/App/Equities/shared/components"
import { useInstrumentMap } from "@/App/Equities/shared/services/instruments"
import { useOrderHistory } from "@/App/Equities/shared/services/orderHistory"
import { Typography } from "@/generated/material"

import { List } from ".."
import { ORDER_HISTORY_PAGE_LOCATORS } from "./locators"
import { OrderHistoryListItem } from "./OrderHistoryListItem"

export const OrderHistory = () => {
  const { t } = useTranslation()
  return (
    <SimpleViewLayout
      data-testid="order-history-layout"
      routePattern={RootPath.orderHistory}
      header={
        <Typography variant="Display md/Semibold">
          {t("orderHistory")}
        </Typography>
      }
    >
      <ErrorBoundary fallback={<div>{t("errorLoadingOrderHistory")}</div>}>
        <Subscribe fallback={<Loading />}>
          <OrderHistoryList />
        </Subscribe>
      </ErrorBoundary>
    </SimpleViewLayout>
  )
}

const OrderHistoryList = () => {
  const orderHistory = useOrderHistory()
  const instruments = useInstrumentMap(
    orderHistory.map((order) => order.symbol).join(","),
  )
  const enrichedOrders = orderHistory.map((order) => ({
    ...order,
    instrument: instruments.get(order.symbol),
  }))

  return (
    <List data={enrichedOrders} keyField="id">
      {(orderHistory, index) => (
        <OrderHistoryListItem
          {...orderHistory}
          data-testid={`${ORDER_HISTORY_PAGE_LOCATORS.main}.row.${index}`}
        />
      )}
    </List>
  )
}
